export function canDeleteDapp(releaseCount: number): boolean {
  return releaseCount === 0;
}

export function getDappDeletionConstraintMessage(
  releaseCount: number,
): string | null {
  if (canDeleteDapp(releaseCount)) {
    return null;
  }

  return `This dapp has ${releaseCount} active ${
    releaseCount === 1 ? 'release' : 'releases'
  }. Delete all releases before deleting the dapp.`;
}
